import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { reApi, errMsg, rePref, reWorkflowClient } from "@/lib/residentApi";
import { useIsSuper } from "@/components/nds/windows/finance/InvoiceActions";
import WorkflowContent from "@/components/nds/windows/finance/WorkflowContent";
import { btnGold, field } from "@/components/nds/windows/finance/parts";

const KEYS = ["property_name", "address", "city", "state", "zip", "total_beds", "notes"];

function EditProperty({ rec, reload }) {
  const isSuper = useIsSuper();
  const [f, setF] = useState(() => ({ ...Object.fromEntries(KEYS.map((k) => [k, String(rec[k] ?? "")])), house_manager_id: rec.house_manager_id || "" }));
  const [hms, setHms] = useState([]);
  useEffect(() => { if (isSuper) reApi.get("/sa/staff").then((d) => setHms(d.staff.filter((u) => u.staff_permissions.includes("house_manager")))).catch(() => {}); }, [isSuper]);
  if (!isSuper) return null;
  const set = (k) => (e) => setF((s) => ({ ...s, [k]: e.target.value }));
  const save = async () => {
    try { await reApi.patch(`/sanctuary/properties/${rec.id}`, { ...f, total_beds: Number(f.total_beds), house_manager_id: f.house_manager_id || null }); toast.success("Property updated"); reload(); }
    catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div data-testid="re-prop-edit" className="p-4 border border-white/10 rounded-sm space-y-3">
      <span className="font-mono text-[10px] tracking-[0.2em] uppercase text-nex-muted">Edit property</span>
      <div className="grid grid-cols-2 md:grid-cols-3 gap-2">
        {KEYS.map((k) => <input key={k} value={f[k]} onChange={set(k)} placeholder={k.replace("_", " ")} type={k === "total_beds" ? "number" : "text"} data-testid={`re-prop-edit-${k}`} className={`${field} !py-1`} />)}
        <select value={f.house_manager_id} onChange={set("house_manager_id")} data-testid="re-prop-edit-house_manager_id" className={`${field} !py-1`}>
          <option value="">No house manager</option>{hms.map((u) => <option key={u.id} value={u.id}>{u.name || u.email}</option>)}</select>
      </div>
      <div className="flex justify-end"><button type="button" onClick={save} data-testid="re-prop-edit-save" className={btnGold}>Save property</button></div>
    </div>
  );
}

const CFG = {
  key: "properties", api: "/sanctuary/properties", client: reWorkflowClient, pref: rePref, testid: "re-prop", label: "Property", plural: "properties",
  createSa: true, noLedger: true, noDocs: true,
  summaryTone: "green", summaryText: (s) => `${s.count} active · ${s.occupancy_pct}% occupied`,
  chips: { active: ["green", "Active"], inactive: ["grey", "Inactive"] },
  form: [{ k: "property_name", label: "Property name", type: "text" }, { k: "total_beds", label: "Total beds", type: "number" }, { k: "address", label: "Address", type: "text", optional: true },
    { k: "city", label: "City", type: "text", optional: true }, { k: "state", label: "State", type: "text", optional: true }, { k: "zip", label: "ZIP", type: "text", optional: true },
    { k: "notes", label: "Notes", type: "text", optional: true, wide: true }],
  actions: [
    { name: "deactivate", label: "Deactivate", from: ["active"], sa: true, tone: "red" },
    { name: "activate", label: "Activate", from: ["inactive"], sa: true, tone: "green" },
  ],
  row: (r) => <><span className="text-nex-silver font-medium">{r.property_name}</span><span className="text-xs text-nex-muted truncate max-w-[220px]">{[r.address, r.city, r.state].filter(Boolean).join(", ")}</span><span className="text-xs text-nex-muted">{r.house_manager?.name || "no house manager"}</span></>,
  amount: (r) => <span className="font-mono text-xs text-nex-silver">{r.active_beds}/{r.total_beds} beds · {r.occupancy_pct}%</span>,
  title: (r) => r.property_name,
  fields: (r) => [["Address", [r.address, r.city, r.state, r.zip].filter(Boolean).join(", ")], ["Beds", `${r.active_beds} occupied of ${r.total_beds} (${r.vacant_beds} vacant)`], ["House manager", r.house_manager?.name], ["Rooms on file", (r.rooms || []).map((x) => x.name).join(", ")], ["Notes", r.notes]],
  Extra: ({ rec, reload }) => <EditProperty key={`${rec.id}-${rec.history?.length}`} rec={rec} reload={reload} />,
};
export default function RePropertiesContent() { return <WorkflowContent cfg={CFG} />; }
